// extracted by mini-css-extract-plugin
module.exports = {"container":"_3G28xoCgw7zJqL6FPbM3lC","title":"_2XaFgC565FUNcxw19B4z0M","divider":"_37MpvQkoo6rx7QKsMFB_yR","list":"JuY2rcu-FbfCZq4F46LET"};